export default __webpack_public_path__ + "static/media/marketplace-volume.0e846333.svg";